import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Convert File to Base64
export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64 = reader.result as string;
      resolve(base64.split(',')[1]);
    };
    reader.onerror = reject;
  });
};

// Convert SVG to PNG 
export const svgToPngFile = async (file: File): Promise<File> => {
  if (file.type !== 'image/svg+xml') return file;

  let svgText = await file.text();

  const svgBlob = new Blob([svgText], {
    type: 'image/svg+xml;charset=utf-8'
  });

  const url = URL.createObjectURL(svgBlob);

  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.src = url;

  await new Promise<void>((resolve, reject) => {
    img.onload = () => resolve();
    img.onerror = () =>
      reject(new Error('SVG rendering failed (unsupported SVG content)'));
  });

  const canvas = document.createElement('canvas');
  canvas.width = img.width || 1024;
  canvas.height = img.height || 1024;

  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas not supported');

  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

  const blob = await new Promise<Blob>((resolve, reject) => {
    canvas.toBlob(
      b => (b ? resolve(b) : reject(new Error('PNG conversion failed'))),
      'image/png'
    );
  });

  URL.revokeObjectURL(url);

  return new File(
    [blob],
    file.name.replace(/\.svg$/i, '.png'),
    { type: 'image/png' }
  );
};